import apiUrl from "./config/config";
import axios from "axios";

class superheatApi {


  //Get all superheats
  static async getSuperheats(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "superheat", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }


}


export default superheatApi;
